import { render, staticRenderFns } from "./SendPost.vue?vue&type=template&id=2ee2bd2a&scoped=true"
import script from "./SendPost.vue?vue&type=script&lang=js"
export * from "./SendPost.vue?vue&type=script&lang=js"
import style0 from "./SendPost.vue?vue&type=style&index=0&id=2ee2bd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee2bd2a",
  null
  
)

export default component.exports